<template>
    <v-layout row wrap class="symptoms-questions-content pro-symptoms-priority-list">


        <v-flex xs12 sm3 lg2 class="related-symptoms">
            <related-symptoms ref="relatedSymptomsRef"
                              @emitRelatedSymptomClick="onRelatedSymptomClick"
                              @emitRelatedSymptomsPanelClick="onRelatedSymptomsPanelClick"
                              @emitNoOtherSymptomsPanelClick="onNoOtherSymptomsPanelClick"
                              :shortcutNav="shortcutNav">
            </related-symptoms>
        </v-flex>

        <v-flex xs12 sm9 lg10 class="selected-symptoms no-padding-top">
            <v-container fluid class="no-padding-top padding-right-xs">
                <v-layout row wrap>
                    <v-flex  xs12 sm8 lg9 >
                        <symptoms-priority-list ref="symptomsPriorityListRef"
                                                :shortcutNav="this.shortcutNav"
                                                @emitChangeAnswer="onChangeAnswer"
                                                @emitQuestionClick="onQuestionClick">
                        </symptoms-priority-list>
                    </v-flex>
                    <v-flex xs12 sm4 lg3 class="fixed-symptom-description">
                        <v-card class="symptom-description component-bg-color" v-if="symptomName" :height="null">
                            <v-card-title v-if="symptomName">
                                <h4 v-if="relatedSymptomName">
                                    {{relatedSymptomName}}: {{symptomName}}
                                </h4>
                                <h4 v-else>
                                    {{symptomName}}
                                </h4>
                                <div v-html="symptomText"></div>
                            </v-card-title>
                            <v-card-title v-if="!symptomName">
                                No symptom selected
                            </v-card-title>
                            <v-card-text class="px-0">
                               <div v-html="symptomDescription" class="symptom-description-html"></div>
                            </v-card-text>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>

        </v-flex>

    </v-layout>
</template>

<!-- ################################################################## -->

<script>
    import RelatedSymptoms from "../RelatedSymptoms";
    import SymptomsPriorityList from "./SymptomsPriorityList";
    import { mapGetters } from 'vuex';

    export default {
        name: 'SymptomsQuestionsContentListMode',
        components: {
            SymptomsPriorityList,
            RelatedSymptoms
        },
        computed: mapGetters({
            symptomDescription: 'SymptomsQuestionsStore/getSymptomDescription',
            symptomName: 'SymptomsQuestionsStore/getSymptomName',
            symptomText: 'SymptomsQuestionsStore/getSymptomText',
            relatedSymptomName: 'SymptomsQuestionsStore/getRelatedSymptomName'
        }),

        props: ["shortcutNav"],

        methods: {

            onChangeAnswer(data) {
                this.$emit('emitChangeAnswer', data);
            },

            onQuestionClick(data) {
                this.$emit('emitQuestionClick', data);
            },

            onRelatedSymptomClick(data) {
                this.$emit('emitRelatedSymptomClick', data);
            },

            onRelatedSymptomsPanelClick() {
                this.$emit('emitRelatedSymptomsPanelClick');
            },

            onNoOtherSymptomsPanelClick() {
                this.$emit('emitNoOtherSymptomsPanelClick');
            }

        }

    }
</script>

<!-- ################################################################## -->

<style lang="scss" scoped>
    .symptom-description {
        min-height: 200px;
        padding: 0px;

        .card__title {
            display: block !important;
            padding: 20px;
            padding-bottom: 10px;
        }
    }


    @media only screen and (min-width: 600px) {
        .symptom-description {
            // 83px - page header
            // 61px - top bar
            // 60px - bottom bar
            // 34px - blank space above the Symptom Description box.
            // 16px - blank space below the Symptom Description box.
            height: calc(100vh - 83px - 61px - 60px - 34px - 16px);
            overflow: auto;
        }
    }

    /*@media only screen and (min-height:400px) and (max-height: 579px) {
        .symptom-description-html {
            height: 100px;
        }
    }


    @media only screen and (min-height:580px) and (max-height: 659px) {
        .symptom-description-html {
            height: 210px;
        }
    }

    @media only screen and (min-height: 660px) and (max-height: 750px) {
        .symptom-description-html {
            height: 280px;
        }
    }

    @media only screen and (min-height: 751px) and (max-height: 851px) {
        .symptom-description-html {
            height: 390px;
        }
    }

    @media only screen and (min-height: 852px) and (max-height: 1100px) {
        .symptom-description-html {
            height: 500px;
        }
    }*/

    @media only screen and (max-height: 499px) and (min-width: 960px) {
        .fixed-symptom-description {
           // position: relative;
            right: 0;
        }
        .symptom-description-html {
            position: relative;
            //height: auto;
            //max-height: auto;
        }
    }

    .symptom-description-html {
        padding-left: 20px;
    }

</style>



// WEBPACK FOOTER //
// src/professional/components/symptoms-questions/symptoms-priority-list/SymptomsQuestionsContentListMode.vue